import React from 'react'
import { DateTimePicker } from 'react-widgets'
import { isNumber, isString, isBoolean, omit } from 'lodash'
import m from 'moment'
import {
  Row, Col, Modal, ButtonGroup,
  Form, FormGroup, FormControl, ControlLabel, Checkbox, Radio
} from 'react-bootstrap'

import MarkdownField from '../lib/MarkdownField'
import Button from '../components/Button'
import { getText } from '../lib/text.js'
import { round, printMoney, str2date, date2str } from '../../lib/Tools'
import { eur2yuan, yuan2eur } from '../lib/exchangeRateClient'

// @TODO many texts here are missing in text_data

/**
 *
 */

type ModalProps = {
  payment: Object,
  onChange: (Object => void),
  onCancel: () => void,
  isNewPayment: boolean
}

class PaymentModal extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      isEurEdited: !(props.isNewPayment),
      isYuanEdited: !(props.isNewPayment),
    }
  }

  props : ModalProps

  render() {
    const { payment, onChange, onCancel } = this.props
    const isReceived = (isBoolean(this.state.isReceived) ? this.state.isReceived : payment.isReceived)
    return (
      <Modal show onHide={() => this.props.onCancel()}>
        <Modal.Header>
          <Modal.Title>
            {getText("Editar pago")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form className="tripDates" style={{ marginLeft: 20, marginRight: 20 }}>
            <FormGroup>
              <ControlLabel>{getText("Nombre")}</ControlLabel>{"   "}
              <FormControl
                bsSize="small"
                value={(isString(this.state.name) ? this.state.name : payment.name)}
                onChange={evt => { this.setState({ name : evt.target.value }) }}
              />
            </FormGroup>

            <FormGroup>
              <ControlLabel>{getText("Fecha de transferencia")}</ControlLabel>
              <DateTimePicker
                calendar
                time={false}
                format="YYYY/MM/DD"
                value={isString(this.state.sentDate) ? str2date(this.state.sentDate) : str2date(payment.sentDate || m().format("YYYY/MM/DD"))}
                onChange={d => { this.setState({ sentDate : date2str(d) }) }}
              />
            </FormGroup>

            <Row>
              <Col md={5}>
                <FormGroup>
                  <ControlLabel>{getText("Euros*")}</ControlLabel>{"   "}
                  <FormControl
                    bsSize = "small"
                    value={
                      this.state.isEurEdited
                        ? (isNumber(this.state.eur) ? this.state.eur : payment.eur || 0)
                        : printMoney(isNumber(this.state.eur) ? this.state.eur : payment.eur || 0, true, false)
                    }
                    type="number"
                    style={this.state.isEurEdited ? {} : { fontStyle: "italic" }}
                    onChange={evt => {
                      // #TODO allow 0, or allow to delete the last digit
                      this.setState({ isEurEdited : true })
                      const eur = Number.parseFloat(evt.target.value || 0) || 0
                      if (isNumber(eur)) {
                        this.setState({
                          eur,
                          ...(!this.state.isYuanEdited ? { yuan: round(eur2yuan(eur), 0.01) } : {})
                        })
                      }
                    }}
                  />
                </FormGroup>
              </Col>

              <Col md={2}>
                <ButtonGroup vertical>
                  <Button
                    tooltipText="Convertir a Yuanes"
                    onClick={() => {
                      const yuan = round(eur2yuan(isNumber(this.state.eur) ? this.state.eur : payment.eur || 0), 0.01)
                      this.setState({ isYuanEdited: true, yuan })
                    }}
                  >
                    {"€ ⇒ ¥"}
                  </Button>
                  <Button
                    tooltipText="Convertir a Euros"
                    onClick={() => {
                      const eur = round(yuan2eur(isNumber(this.state.yuan) ? this.state.yuan : 0), 0.01)
                      this.setState({ isEurEdited: true, eur })
                    }}
                  >
                    {"€ ⇐ ¥"}
                  </Button>
                </ButtonGroup>
              </Col>

              <Col md={5}>
                <FormGroup>
                  <ControlLabel>{getText("Yuanes")}</ControlLabel>{"   "}
                  <FormControl
                    bsSize="small"
                    value={
                      this.state.isYuanEdited
                        ? (isNumber(this.state.yuan) ? this.state.yuan : payment.yuan || 0)
                        : printMoney(isNumber(this.state.yuan) ? this.state.yuan : payment.yuan || 0, true, false)
                    }
                    type="number"
                    style={this.state.isYuanEdited ? {} : { fontStyle: "italic" }}
                    onChange={evt => {
                      this.setState({ isYuanEdited : true })
                      const yuan = Number.parseFloat(evt.target.value) || 0
                      if (isNumber(yuan)) {
                        if (!this.state.isEurEdited) this.setState({ eur : round(yuan2eur(yuan), 0.01) })
                        this.setState({ yuan })
                      }
                    }}
                  />
                  <span style = {{ float : "left", fontStyle: "italic" }}>
                    {getText(`Cambio hoy: ${printMoney(yuan2eur(isNumber(this.state.yuan) ? this.state.yuan : payment.yuan || 0))}€`)}
                  </span>
                </FormGroup>
              </Col>
            </Row>

            {(this.state.paymentMethod == "tripmaker" || payment.paymentMethod == "tripmaker") && (
              <div style={{ color: 'red' }}>No usar metodo de pago Tripmaker para pagos superiores a 500€</div>
            )}

            <hr />

            <FormGroup>
              <ControlLabel>{getText("Método de pago*")}</ControlLabel>
              {
                // #TODO the list of possible methods should be centralized (in duck?)
                ["tripmaker", "bank", "wechat", "online", "tpv", "cash", "other"]
                  .map(method => (
                    <Radio
                      disabled = {payment.paymentMethod == "tripmaker"}
                      key={method}
                      name={method}
                      checked={(this.state.paymentMethod || payment.paymentMethod) == method}
                      onChange={() => this.setState({ paymentMethod: method })}
                    >
                      {getText(`method_${method}`)}
                    </Radio>
                  ))
              }
            </FormGroup>

            {
              /**
               * #TODO: Los inputs numéricos tienen limitaciones y problemas. quizá haga falta generalizar la estrategia que sigue el PriceEditor, que funciona bien.
               */
            }

            <Checkbox
              style={{ marginBottom: 10 }}
              checked={isReceived}
              onChange={evt => this.setState({
                isReceived: evt.target.checked,
                // if a received amount had already been introduced, use that; if not, use the sent amount as a default
                receivedEur: this.state.receivedEur || payment.receivedEur || this.state.eur || payment.eur,
                receivedDate: m().format("YYYY/MM/DD")
              })}
            >
              <span style={{ fontWeight: "bold" }}>{getText("Pago recibido")}</span>
            </Checkbox>

            <Row>
              <Col md={6}>
                <FormGroup>
                  <ControlLabel>{getText("Fecha de pago recibido")}</ControlLabel>
                  <DateTimePicker
                    disabled={!isReceived}
                    calendar
                    time={false}
                    format="YYYY/MM/DD"
                    value={
                      isReceived
                        ? (isString(this.state.receivedDate) ? str2date(this.state.receivedDate) : str2date(payment.receivedDate))
                        : ""
                    }
                    onChange={d => {
                      this.setState({ receivedDate: date2str(d) })
                    }}
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <ControlLabel>{getText("Recibido (€)")}</ControlLabel>{"   "}
                  <FormControl
                    bsSize="small"
                    value={
                      isReceived
                        ? (isNumber(this.state.receivedEur) ? this.state.receivedEur : payment.receivedEur)
                        : ""
                    }
                    type="number"
                    disabled={!isReceived}
                    onChange={evt => {
                      const receivedEur = Number.parseFloat(evt.target.value)
                      if (isNumber(receivedEur)) this.setState({ receivedEur })
                    }}
                  />
                </FormGroup>
              </Col>
            </Row>

            <hr />

            <MarkdownField
              label={getText("Comentario")}
              value={isString(this.state.comment) ? this.state.comment : payment.comment}
              onChange={comment => this.setState({ comment })}
            />
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <span style = {{ float : "left" }}>{getText("Rellene los campos obligatorios (*)")}</span>
          <Button onClick={() => onCancel()}>
            {getText("Cancelar")}
          </Button>
          <Button
            bsStyle="success"
            onClick={() => {
              if (
                (!isNumber(this.state.eur) && !isNumber(payment.eur))
                || (!isString(this.state.paymentMethod) && !isString(payment.paymentMethod))
                || (isNumber(this.state.eur) ? this.state.eur == 0 : payment.eur == 0)
              ) {
                alert(getText("Rellene los campos obligatorios (*)"))
              }
              else onChange({ ...payment, ...(omit(this.state, ["isEurEdited", "isYuanEdited"])) })
            }}
          >
            {getText("Guardar")}
          </Button>
        </Modal.Footer>
      </Modal>
    )
  }
}

export default PaymentModal
